module.exports = __webpack_public_path__ + "img/budpostach.66641ffa.jpg";